import * as Yup from 'yup';
import { HRInterviewFormModel } from './types';

export const hrInterviewFormValidationSchema = (hiddenFields: Partial<Record<keyof HRInterviewFormModel, boolean>> = {}) => {
  const {
    date, time, supervisorEmail, assigneeEmail, address, interviewerEmail,
  } = hiddenFields;

  return Yup.object({
    supervisorEmail: supervisorEmail
      ? Yup.string().notRequired()
      : Yup.string().required('Il campo è obbligatorio'),
    assigneeEmail: assigneeEmail
      ? Yup.string().notRequired()
      : Yup.string().required('Il campo è obbligatorio'),
    date: date
      ? Yup.string().notRequired()
      : Yup.string().required('Il campo è obbligatorio'),
    time: time
      ? Yup.string().notRequired()
      : Yup.string().required('Il campo è obbligatorio'),
    interviewerEmail: interviewerEmail
      ? Yup.string().notRequired()
      : Yup.string().required('Il campo è obbligatorio'),
    isRemote: Yup.string().required('Il campo è obbligatorio'),
    address: Yup.object().when('isRemote', {
      is: (isRemote: string) => isRemote === 'false' && !address,
      then: () => Yup.object({
        normalizedAddress: Yup.object({
          description: Yup.string().required('Il campo è obbligatorio'),
        }).required('Il campo è obbligatorio'),
      }).required('Il campo è obbligatorio'),
      otherwise: () => Yup.object().notRequired(),
    }),
  }).test(
    'future-datetime',
    'La data e ora devono essere nel futuro',
    (values, ctx) => {
      const { date: d, time: t } = values || {};

      if (!d || !t) return true;

      const datetime = new Date(`${d}T${t}`);

      if (Number.isNaN(datetime.getTime())) return true;

      if (datetime.getTime() <= Date.now()) {
        return ctx.createError({
          path: 'date',
          message: 'La data e ora devono essere nel futuro',
        });
      }

      return true;
    },
  );
};
